import router from '@/router'

import axios from 'axios'



const messageCampaignModule = {
  state: {
    items: null,
    pagination: null,
    params: null
  },
  mutations: {
    setMessageCompaing (state, data) {
      state.items = data
    },
    setMessageCompaingById (state, data) {
      state[data.data_message_campaing.id] = data.data_message_campaing
      state[data.data_message_campaing.id].params_request_message_campaing = {
        show_test_emails: data.show_test_emails,
        time_info_start: data.time_info_start,
        time_info_end: data.time_info_end,
      }
    },
    setMessageCompaingPagination (state, data) {
      state.pagination = data
    },
    setMessageCompaingParams (state, data) {
      state.params = data
    },
    setRecipientsMessageCompaing (state, data) {
      state[data.id].info_recipcient_message_compaing = data.recipients
    },
    setParamsTableMessageCompaing (state, data) {
      state[data.id].param_table_message_compaing = data.params
    }
  },
  getters: {
    getMessageCompaing: (state) => {
      return state.items
    },
    getMessageCompaingPagination: (state) => {
      return state.pagination
    },
    getMessageCompaingById: (state) => (id) => {
      return state[id]
    },
    getParamTableMessageCompaing: (state) => (id) => {
      return state[id] && state[id].param_table_message_compaing ? state[id].param_table_message_compaing : null
    }
  },
  actions: {
    async deleteMessageCompaing ({commit, rootGetters}, ids) {
      const responses = await Promise.all(ids.map(async (campaign) => {
        try {
          const response = await axios({
            url: `${rootGetters.getBackendUrl}/messages/${campaign.id}`,
            method: 'delete',
            headers: {
              'Accept-Language': rootGetters.getLanguage,
              'Auth-Token': rootGetters.getToken,
              'Leadhit-Site-Id': rootGetters.getSiteId
            }
          })
          return { ok: true, status: response.status, id: campaign.id }
        } catch (error) {
          return {
            ok: false,
            status: error.response && error.response.status,
            id: campaign.id
          }
        }
      }))

      return responses
    }
  }
}

export default messageCampaignModule



// WEBPACK FOOTER //
// ./src/store/modules/message campaign.js